// Import useAuthState from its submodule rather than the `common/hooks` barrel:
// this hook is consumed by the smart-apply components, and the barrel transitively
// reaches them, so a barrel import here would re-introduce an import cycle.
import { useAuthState } from '@percent/cause-dashboard/common/hooks/useAuthState/useAuthState'
import { SMART_APPLY_GRANT_ADVISORY_SOURCE } from './grantAdvisoryBooking.utils'

// Analytics properties for the grant advisory booking flow when surfaced after a
// smart apply run. Shared by both entry points (IntroModals + PopUpModalContainer)
// so the property shape stays in sync.
export const useGrantAdvisoryTrackingProperties = () => {
  const { authState } = useAuthState()

  return {
    organisation: authState.claimOrganisation?.displayName,
    organisationId: authState.claimOrganisation?.id,
    source: SMART_APPLY_GRANT_ADVISORY_SOURCE,
    accountId: authState.user?.id
  }
}
